import { View, type ViewProps } from "react-native";
import { radii, semanticColors, shadows, spacing } from "../theme/tokens";

type Props = ViewProps & {
  variant?: "default" | "outlined" | "filled";
  accentColor?: string;
  padding?: keyof typeof spacing;
};

export function MoonCard({
  variant = "default",
  accentColor,
  padding = "lg",
  style,
  children,
  ...rest
}: Props) {
  const paddingValue = spacing[padding];

  const baseStyle = {
    borderRadius: radii.lg,
    padding: paddingValue,
    ...(variant === "default" && {
      backgroundColor: semanticColors.surface.default,
      borderWidth: 1,
      borderColor: semanticColors.border.default,
    }),
    ...(variant === "outlined" && {
      backgroundColor: semanticColors.surface.transparent,
      borderWidth: 1,
      borderColor: semanticColors.border.default,
      borderStyle: "dashed" as const,
    }),
    ...(variant === "filled" && {
      backgroundColor: semanticColors.surface.raised,
      ...shadows.sm,
    }),
  };

  return (
    <View style={[baseStyle, style]} {...rest}>
      {accentColor && (
        <View
          style={{
            position: "absolute",
            left: 0,
            top: 12,
            bottom: 12,
            width: 3,
            borderRadius: 2,
            backgroundColor: accentColor,
          }}
        />
      )}
      {children}
    </View>
  );
}
